import { CoreEvent, eventNames } from '@carvana/core-events';
import { PrimaryTextButton } from '@carvana/merch-components/helios/TextButton';
import HeartWithBorder from '~/icons/HeartWithBorder';
import HeartWithBorderThin from '~/icons/HeartWithBorderThin';
import { ToastAction, ToastView, ToastViews } from './types';

type OwnProps = {
  action: ToastAction;
  view?: ToastView;
};

export default function FavoritesToastContent({
  action,
  view = ToastViews.vehicles
}: OwnProps) {
  const isAdding = action === 'add';
  const text = isAdding
    ? 'Added to your favorites'
    : 'Removed from your favorites';

  return (
    <div className="flex w-auto items-center justify-between gap-md t-heading-sm">
      {isAdding ? (
        <HeartWithBorderThin className="h-20 w-20" isFavorited />
      ) : (
        <HeartWithBorder darkGray className="h-16 w-16" />
      )}
      <span className="whitespace-nowrap">{text}</span>
      {isAdding && (
        <PrimaryTextButton
          data-analytics-id="Favorites"
          data-analytics-attributes={JSON.stringify({
            description: 'toast view button',
            type: view
          })}
          size="sm"
          onClick={() => {
            CoreEvent.emit(eventNames.favorites.mfe.drawer.open, {
              tab: view
            });
          }}
        >
          View
        </PrimaryTextButton>
      )}
    </div>
  );
}
